export class Spring {

  /*** Tabla: FASOLICI ***/
  FASOLICI = 'Fasolici/';
  FASOLICI_SOLICITUDES_CLIENTE = 'Fasolici/solicitudesCliente/';
  FASOLICI_SOLICITUDES_GENERAL = 'Fasolici/solicitudesGeneral/';
  FASOLICI_SOLICITUDES_PROVEEDOR = 'Fasolici/solicitudesProveedor/';
  FASOLICI_DETALLE_SOLICITUD = 'Fasolici/detalleSolicitud/';
  FASOLICI_DETALLE_SOLICITUD_CODIFICADO = 'Fasolici/detalleSolicitudCodificado/';
  FASOLICI_FILTRO_FOLIO_CLIENTE = 'Fasolici/filtroFolioCliente/';
  FASOLICI_FILTRO_FOLIO_GENERAL = 'Fasolici/filtroFolioGeneral/';
  FASOLICI_FILTRO_FECHAS_CLIENTE = 'Fasolici/filtroFechasCliente/';
  FASOLICI_FILTRO_FECHAS_GENERAL = 'Fasolici/filtroFechasGeneral/';
  FASOLICI_FILTRO_MONEDA_CLIENTE = 'Fasolici/filtroMonedaCliente/';
  FASOLICI_FILTRO_MONEDA_GENERAL = 'Fasolici/filtroMonedaGeneral/';
  FASOLICI_DETALLE_SOLICITUD_POSTREGISTRO = 'Fasolici/detalleSolicitudPostRegistro/';
  FASOLICI_ENVIAR_CORREO_SOLICITUD = 'Fasolici/enviaCorreo/';
  FASOLICI_ESTATUS_SOLICITUD = 'Fasolici/estatusSolicitud/';
  FASOLICI_ESTATUS_SOLICITUD_AFINGANA = 'Fasolici/estatusSolicitudAfingana/';
  FASOLICI_SOLICITUDES_PENDIENTES_PROVEEDOR = 'Fasolici/pedientesFactorajeProveedor/';
  FASOLICI_BANAMEX = 'Fasolici/bancoBanamex/';
  FASOLICI_INTERBANCARIOS = 'Fasolici/bancoInterbancarios/';
  FASOLICI_VALIDAR_SOLICITUD = 'Fasolici/ligaCodificada/';
  FASOLICI_GET_LIST_FALINEA = 'Fasolici/getListFalinea/';

  /*** Tabla FAFACTUR ***/
  FAFACTUR_FACTURAS_SOLICITUD = 'Fafactur/facturasSolicitudFactoraje/';
  FAFACTUR_FOLIOS_FACTURAS_CLIENTE = 'Fafactur/foliosFacturasCliente/';

  /*** TABLA PSPERFAC ***/
  PSPERFAC_PROVEEDORES_CLIENTE = 'Psperfac/listadoProveedores/';

  /*** TABLA PSCTABAN ***/
  PSCTABAN_CUENTAS_PROVEEDOR = 'Psctaban/listadoCuentasProveedores/';
  PSCTABAN_IDCTABAN = 'Psctaban/getCuentaProveedorId/';
  PSCTABAN_PERSONA = 'Psctaban/getCuentasBancariasPersona/';
  PSCTABAN_POST = 'Psctaban/postPsctaban/';

  /** TABLA PSACCION **/
  PSACCION = 'Psaccion';
  PSACCION_GET_LIST_BY_IDPERSON = 'Psaccion/getListPsaccionByIdperson/';
  PSACCION_GET_BY_ID = 'Psaccion/getPsaccionById/';
  PSACCION_GET_PDF = 'Psaccion/getPDF/';

  /*** TABLA FALINEA ***/

  FALINEA_TASA_LINEA = 'Falinea/getTasaLinea/';
  FALINEA_SALDO_MXN = 'Falinea/getSaldoMXN/';
  FALINEA_SALDO_USD = 'Falinea/getSaldoUSD/';
  FALINEA_HAS_LINEA_MXN = 'Falinea/hasLineaMXN/';
  FALINEA_HAS_LINEA_USD = 'Falinea/hasLineaUSD/';

  /** TABLA PSPERSON ***/

  PSPERSON_IDPERSON = 'Psperson/getPersonaId/';
  PSPERSON_TASAFACTORAJE = 'Psperson/tasaFactoraje/';
  PSPERSON_FIDEICOMISO = 'Psperson/listadoPersonasFideicomiso';
  PSPERSON_POST_FIDEICOMISO = 'Psperson/altaFideicomiso';
  PSPERSON_PUT_FIDEICOMISO = 'Psperson/actualizarFideicomiso';
  PSPERSON_PERFIL_PERSONA_FIDEICOMISO = 'Psperson/perfilPersonaFideicomiso/';
  PSPERSON_VALIDAR_RFC = 'Psperson/validarRFC/';

  /*** TABLA USUSUARI ***/
  USUSUARI_CLAVE = 'Ususuari/clave';
  USUSUARI_VALIDA_CLAVE = 'Ususuari/validaClave/';

  /*** TABLA FIFRACCI ***/
  FIFRACCI = 'Fifracci/';
  FIFRACCI_POR_IDFIDEIC = 'Fifracci/idfideic/';

  /** TABLA FIUSLOTE ***/
  FIUSLOTE = 'Fiuslote/';

  /** TABLA FINOTARI **/
  FINOTARI = 'Finotari/';

  /** TABLA FITIPOPE **/
  FITIPOPE = 'Fitipope';

  /** TABLA FICORFIN **/
  FICORFIN = 'Ficorfin';
  FICORFIN_GET_CALCULOS = 'Ficorfin/getCalculosFicorfin/';
  FICORFIN_GET_LIST_BY_IDPERSON = 'Ficorfin/getListFicorfinByIdperson/';
  FICORFIN_BY_ID = 'Ficorfin/getFicorfinById/';
  FICORFIN_EXISTE = 'Ficorfin/getExisteFicorfin/';
  FICORFIN_EXISTE_FIDEICOMISARIO = 'Ficorfin/getExisteFideicomisario/';

  /**  TABLA FICORPAG **/
  FICORPAG = 'Ficorpag';
  FICORPAG_GET_LIST_BY_IDCORFIN = 'Ficorpag/getListFicorpagByIdcorfin/';
  FICORPAG_GET_BY_ID = 'Ficorpag/getById/';

  /** TABLA FICORRET **/
  FICORRET = 'Ficorret';
  FICORRET_GET_LIST_BY_IDCORFIN = 'Ficorret/getListFicorretByIdcorfin/';

  /** TABLA FIFIDEIC **/
  FIFIDEIC = 'Fifideic/';
  FIFIDEIC_ID = 'Fifideic/idfideic/';
  FIFIDEIC_POR_CLIENTE = 'Fifideic/porClientes';
  FIFIDEIC_TOTAL_FIDEICOMISOS = 'Fifideic/totalFideicomisos';


  /** TABLA FIESTATU **/
  FIESTATU = 'Fiestatu/';

  /** TABLA FITIPFIG **/
  FITIPFIG = 'Fitipfig/';

  /** TABLA GLTIPTER **/
  GLTIPTER = 'Gltipter/';
  GLTIPTER_APLICA_FIDEICOMISO = 'Gltipter/aplicaFideicomiso';

  /** TABLA GLTIPMON **/
  GLTIPMON_GET_LIST = 'Gltipmon/getListGltipmon';

  /** TABLA FIETAPAS **/
  FIETAPAS_GET_LIST = 'Fietapas/getListFietapas/';

  /** TABLA FIAVANCE **/
  FIAVANCE_GET_LIST = 'Fiavance/getListFiavance';

  /** TABLA FIPERINV **/
  FIPERINV_GET_LIST = 'Fiperinv/getListFiperinv';

  /** TABLA FICOREST **/
  FICOREST_GET_LIST = 'Ficorest/getListFicorest';

  /** TABLA FITIPMOV **/
  FITIPMOV_GET_LIST = 'Fitipmov/getListFitipmov';

  /** TABLA PSPERFID **/
  PSPERFID = 'Psperfid/';
  PSPERFID_POR_IDFIDEIC = 'Psperfid/idfideic/';
  PSPERFID_GENERAL = 'Psperfid/general';
  PSPERFID_LISTADO = 'Psperfid/listadoDetallado/';
  PSPERFID_LISTADO_PADRE = 'Psperfid/listadoDetalladoPadre/';
  PSPERFID_LISTADO_TERCEROS = 'Psperfid/listadoTerceros/';
  PSPERFID_LISTADO_TERCEROS_GENERAL = 'Psperfid/generalTerceros';
  PSPERFID_FORMATO_IDENTIFICACION = 'Psperfid/formatoIdentificacion/';
  PSPERFID_DELETE = 'Psperfid/delete/';

  /** TABLA PSDOMICI **/
  PSDOMICI = 'Psdomici/';
  PSDOMICI_DOMICILIO_PERSONA = 'Psdomici/detallesDomicilioPersona/';

  /** TABLA PSDECLAR **/
  PSDECLAR = 'Psdeclar/';
  PSDECLAR_PERSONA = 'Psdeclar/declaraciones/';

  /** TABLA PSTELEFO **/
  PSTELEFO = 'Pstelefo/';
  PSTELEFO_PERSONA = 'Pstelefo/telefonosPersona/';

  /** TABLA PSREFERE **/
  PSREFERE = 'Psrefere/';
  PSREFERE_PERSONA_COMERCIAL = 'Psrefere/referenciasPersonaComercial/';
  PSREFERE_PERSONA_PERSONAL = 'Psrefere/referenciasPersonaPersonal/';

  /** TABLA LOTES **/
  FILOTES = 'Filotes/';
  FILOTES_ESTADO_CUENTA = 'Filotes/estadoCuenta';
  FILOTES_IDLOTE = 'Filotes/idlote/';
  FILOTES_POR_IDFIDEIC = 'Filotes/idfideic/';
  FILOTES_BUSQUEDA = 'Filotes/busqueda/';
  FILOTES_CUENTAS_BANCARIAS_FIDEICOMISARIOS_ORDENTANTE = 'Filotes/cuentasBancariasFideicomisariosoOrdenante/';
  FILOTES_CUENTAS_BANCARIAS_FIDEICOMISARIOS_BENEFICIARIA = 'Filotes/cuentasBancariasFideicomisariosoBeneficiaria/';
  FILOTES_CAMBIO_ESTATUS = 'Filotes/cambioEstatus/';
  FILOTES_GENERAR_DOCUMENTO = 'Filotes/generarDocumento/';
  FILOTES_NUMERO_CARTAS_FIRMADAS = 'Filotes/getNumeroCartasFirmadas/';
  FILOTES_NUMERO_ADJUNTOS_FIGURAS = 'Filotes/getNumeroAdjuntosFiguras/';
  FILOTES_EXISTE_FACTURA_INTERESES = 'Filotes/getExisteFacturaIntereses/';

  /** TABLA FIMOVINV **/
  FIMOVINV = 'Fimovinv';
  FIMOVINV_GET_LIST_BY_IDFIDEIC = 'Fimovinv/getListFimovinvByIdfideic/';
  FIMOVINV_GET_BY_ID = 'Fimovinv/getFimovinvById/';
  FIMOVINV_GET_SALDOS_BY_IDFIDEIC = 'Fimovinv/getSaldosFimovinvByIdfideic/';

  /** TABLA FIMOVIMI **/
  FIMOVIMI = 'Fimovimi';
  FIMOVIMI_GET_LIST_BY_IDFIDEIC = 'Fimovimi/getListFimovimiByIdfideic/';
  FIMOVIMI_BY_ID = 'Fimovimi/getFimovimiById/';

  /** TABLA FIPAGOS **/
  FIPAGOS = 'Fipagos/';
  FIPAGOS_LOTE = 'Fipagos/listadoPagosLote/';
  FIPAGOS_PDF = 'Fipagos/pdf/';
  FIPAGOS_ELIMINAR = 'Fipagos/eliminar/';
  FIPAGOS_PROCESAR_EXCEL = 'Fipagos/procesarExcel/';
  FIPAGOS_CERTIFICADO_PAGO = 'Fipagos/certificadoPagos/';

  /** TABLA GLREGFIS **/
  GLREGFIS = 'Glregfis/';

  /** TABLA FITERCER **/
  FITERCER = 'Fitercer/';
  FITERCER_IDLOTE = 'Fitercer/idlote/';
  FITERCER_DELETE = 'Fitercer/delete/';
  FITERCER_CAMBIO_ESTATUS = 'Fitercer/cambioEstatus/';

  /** TABLA GLTIPADJ **/
  GLTIPADJ = 'Gltipadj/';
  GLTIPADJ_TIPOADJUNTOS = 'Gltipadj/listaTipoAdjuntos/';
  GLTIPADJ_INMUEBLES = 'Gltipadj/inmuebles/';
  GLTIPADJ_LOTES = 'Gltipadj/lotes/';
  GLTIPADJ_GET_LIST_ADHERENTES = 'Gltipadj/adherentes/';
  GLTIPADJ_GET_LIST_FICORRET = 'Gltipadj/ficorret/';
  GLTIPADJ_GET_LIST_FIMOVIMI = 'Gltipadj/fimovimi/';
  GLTIPADJ_GET_LIST_FIMOVINV = 'Gltipadj/fimovinv/';


  /** TABLA GLGENERO **/
  GLGENERO = 'Glgenero/';

  /** TABLA GLEDOCIV **/
  GLEDOCIV = 'Gledociv/';

  /** TABLA SAFORPAG **/
  SAFORPAG = 'Saforpag/';

  /** TABLA GLNACION **/
  GLNACION = 'Glnacion/';

  /** TABLA GLPAISES **/
  GLPAISES = 'Glpaises';

  /** TABLA GLACTECO **/
  GLACTECO = 'Glacteco/';

  /** TABLA GLTIPVIV **/
  GLTIPVIV = 'Gltipviv';

  /** TABLA GLESTADO **/
  GLESTADO = 'Glestado/';

  /** TABLA GLBANCOS **/
  GLBANCOS = 'Glbancos/';

  /** TABLA GLTIPCTA **/
  GLTIPCTA = 'Gltipcta/';

  /** TABLA GLTIPIDE **/
  GLTIPIDE = 'Gltipide/';

  /** TABLA GLASENTA **/
  GLASENTA = 'Glasenta/';
  GLASENTA_CODIGOPOSTAL = 'Glasenta/codigoPostal/';
  GLASENTA_ASENTAMIENTO = 'Glasenta/asentamiento/';
  GLASENTA_GET_IDASENTA = 'Glasenta/idasenta/';

  /** TABLA GLDIAFES **/
  GLDIAFES_GETFESTIVO = 'Gldiafes/diaFestivo/';

  /** TABLA PSTERCER **/
  PSTERCER = 'Pstercer/';
  PSTERCER_IDPERSON = 'Pstercer/idperson/';
  PSTERCER_DELETE = 'Pstercer/delete/';
  PSTERCER_IDENTIFICACION = 'Pstercer/identificacionTercero/';
  PSTERCER_CAMBIO_ESTATUS = 'Pstercer/cambioEstatus/';
  PSTERCER_SET_FECHA_CONTRATO = 'Pstercer/setFechaContrato/';
  PSTERCER_SET_ESTATUS = 'Pstercer/setEstatus/';
  PSTERCER_GET_LIST_FIDEICOMISARIOS_SUSTITUTOS = 'Pstercer/getFideicomisariosSustitutos/';
  PSTERCER_GET_LIST_BY_IDFIDEIC = 'Pstercer/getListPstercerByIdfideic/';

  /** TABLA PSADJUNT **/
  PSADJUNT = 'Psadjunt';
  PSADJUNT_ID_PERSON_PERSONAL = 'Psadjunt/idperson/';
  PSADJUNT_ID_PERSON_PERSONAL_INMUEBLE = 'Psadjunt/inmueble/idperson/';
  PSADJUNT_PDF = 'Psadjunt/pdf/';
  PSADJUNT_VERIFICAR = 'Psadjunt/verificar/';
  PSADJUNT_ELIMINAR = 'Psadjunt/eliminar/';
  PSADJUNT_CARGADOS = 'Psadjunt/adjuntosCargados/';

  /** TABLA PSADJTER **/
  PSADJTER_GET_LIST_BY_IDTERCER = 'Psadjter/getListPsadjterByIdtercer/';

  /** TABLA FIADJRET **/
  FIADJRET_GET_LIST_BY_IDCORRET = 'Fiadjret/getListFicorretByIdcorret/';

  /** TABLA FIADJMOV **/
  FIADJMOV_GET_LIST_BY_IDMOVIMI = 'Fiadjmov/getListFiadjmovByIdmovimi/';

  /** TABLA FIADJINV **/
  FIADJINV_GET_LIST_BY_IDMOVINV = 'Fiadjinv/getListFiadjinvByIdmovinv/';


  /** TABLA FIADJLOT **/
  FIADJLOT_CARGADOS = 'Fiadjlot/adjuntosCargados/';
  FIADJLOT_CARGADOS_IDLOTE = 'Fiadjlot/idlote/';
  FIADJLOT_PDF = 'Fiadjlot/pdf/';
  FIADJLOT_ELIMINAR = 'Fiadjlot/eliminar/';

  /** TABLA FIADJFIR **/
  FIADJFIR_PDF = 'Fiadjfir/pdf/';
  FIADJFIR_ELIMINAR = 'Fiadjfir/eliminar/';

  /*** FUNCIONES ***/

  FUNCTION_GET_FECHA_VENCIMIENTO = 'Functions/getFechaVencimiento/';
  FUNCTION_GET_DIFERENCIA_DIAS = 'Functions/getDiferenciaDiasFechas/';
  FUNCTION_GET_HORA_SERVIDOR = 'Functions/getHoraServidor';

  /*** CONSUMO DE APIS ***/

  SPOTLIGHT = 'Spotlight';

  /*** TOKEN ***/
  SIGNIN_TOKEN = 'signin';
  REFRESH_TOKEN = 'refreshtoken';
  SIGNOUT_TOKEN = 'signout';

  /** TABLA GLSOCIED **/
  GLSOCIED_GET_LIST = 'Glsocied/getListGlsocied';

  /** TABLA GLACCMOV **/
  GLACCMOV_GET_LIST = 'Glaccmov/getListGlaccmov';

  /** TABLA PSTEREST **/
  PSTEREST_GET_LIST = 'Psterest/getListPsterest';

  // TABLA UPPERMIS
  GET_PERMISOS_USUARIO = 'Uppermis/getPermisosUsuario/';
  UPPERMIS_GET_PERMISO_CONTROL_USUARIO = 'Uppermis/getPermisoControlUsuario/';

  // REPORTES BIRT
  GENERAR_REPORTE_BIRT = 'Birt';

}
